import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Landing from "@/pages/Landing";
import Music from "@/pages/Music";
import Referrals from "@/pages/Referrals";
import Profile from "@/pages/Profile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Notifications from "@/pages/Notifications";
import Messages from "@/pages/Messages";
import Marketplace from "@/pages/Marketplace";
import ListingDetail from "@/pages/ListingDetail";
import MarketChat from "@/pages/MarketChat";
import LegalPage from "@/pages/LegalPage";
import MissionVisionValues from "@/pages/MissionVisionValues";
import Communities from "@/pages/Communities";
import Travel from "@/pages/Travel";
import MyPlans from "@/pages/MyPlans";
import Restaurants from "@/pages/Restaurants";
import RestaurantDetail from "@/pages/RestaurantDetail";
import Saved from "@/pages/Saved";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { PlayerProvider } from "@/context/PlayerContext";
import { ProProvider } from "@/context/ProContext";
import { OnboardingProvider } from "@/context/OnboardingContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import { AuthProvider } from "@/context/AuthContext";
import { SiteConfigProvider } from "@/context/SiteConfigContext";
import OnboardingFlow from "@/components/onboarding/OnboardingFlow";
import PlayerBar from "@/components/music/PlayerBar";
import InstallPrompt from "@/components/app/InstallPrompt";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteConfigProvider>
          <AuthProvider>
          <AdminAuthProvider>
            <ProProvider>
              <PlayerProvider>
                <OnboardingProvider>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/musica" element={<Music />} />
                    <Route path="/referidos" element={<Referrals />} />
                    <Route path="/perfil" element={<Profile />} />
                    <Route path="/mensajes" element={<Messages />} />
                    <Route path="/notificaciones" element={<Notifications />} />
                    <Route path="/marketplace" element={<Marketplace />} />
                    <Route path="/marketplace/chat" element={<MarketChat />} />
                    <Route path="/marketplace/chat/:tid" element={<MarketChat />} />
                    <Route path="/marketplace/:lid" element={<ListingDetail />} />
                    <Route path="/comunidades" element={<Communities />} />
                    <Route path="/viajes" element={<Travel />} />
                    <Route path="/mis-planes" element={<MyPlans />} />
                    <Route path="/restaurantes" element={<Restaurants />} />
                    <Route path="/restaurantes/:rid" element={<RestaurantDetail />} />
                    <Route path="/legal/terminos" element={<LegalPage kind="terminos" />} />
                    <Route path="/legal/privacidad" element={<LegalPage kind="privacidad" />} />
                    <Route path="/legal/cookies" element={<LegalPage kind="cookies" />} />
                    <Route path="/legal/politica-uso" element={<LegalPage kind="politica-uso" />} />
                    <Route path="/mision-vision-valores" element={<MissionVisionValues />} />
                    <Route path="/guardados" element={<Saved />} />
                    <Route path="/landing" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin" element={<AdminDashboard />} />
                  </Routes>
                  <PlayerBar />
                  <OnboardingFlow />
                  <InstallPrompt />
                </OnboardingProvider>
              </PlayerProvider>
            </ProProvider>
          </AdminAuthProvider>
        </AuthProvider>
        </SiteConfigProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="light" richColors closeButton />
    </div>
  );
}

export default App;
